import axios, { AxiosResponse, CancelTokenSource } from "axios"
import {
  AsientoContableModelo111Adapter,
  AsientoContableModelo115Adapter,
  AsientoContableModelo180Adapter,
  AsientoContableModelo190Adapter,
  AsientoContableModelo303Adapter,
  AsientoContableModelo347Adapter,
  AsientoContableModelo349Adapter,
  AsientoContableModelo390Adapter,
  ImportesTotalesAsientoContableAdapter,
  ResumenImpuesto349Adapter,
  ResumenImpuestoOtrosAdapter,
  ResumentImpuesto303and390Adapter,
  ResumentImpuestoIvaDetalle180Adapter,
  ResumentImpuestoIvaDetalle190Adapter,
  ResumentImpuestoIvaDetalle347Adapter,
  ResumentImpuestoIvaDetalleAdapter,
  asientoByIdAdapter,
  asientoDiarioByFilterAdapter,
} from "./AsientoContable.adapter"
import { ImportarAsientosContablesSageCommandProps } from "./Commands/ImportarAsientosContablesSageCommand"
import { ImportarLibroIvaSageCommandProps } from "./Commands/ImportarLibroIvaSageCommand"
import { InsertAsientoContableCommandProps } from "./Commands/InsertAsientoContableCommand"
import { InsertAsientoContableDeLiquidacionCommandProps } from "./Commands/InsertAsientoContableDeLiquidacionCommand"
import { InsertAsientosCierreEjercicioCommandProps } from "./Commands/InsertAsientosCierreEjercicioCommand"
import { UpdateAsientoContableCommandProps } from "./Commands/UpdateAsientoContableCommand"
import { GetAsientoContableByIdDtoProps } from "./DTOs/GetAsientoContableByIdDto"
import { GetImportesLineasAsientosContablesDto } from "./DTOs/GetImportesLineasAsientosContablesDto"
import { GetModelo111DtoProps } from "./DTOs/GetModelo111Dto"
import { GetModelo111ResumenImpuestosDtoProps } from "./DTOs/GetModelo111ResumenImpuestosDto"
import { GetModelo115DtoProps } from "./DTOs/GetModelo115Dto"
import { GetModelo115ResumenImpuestosDtoProps } from "./DTOs/GetModelo115ResumenImpuestosDto"
import { GetModelo180DetalleImpuestosDto } from "./DTOs/GetModelo180DetalleImpuestosDto"
import { GetModelo180DetalleImpuestosDtoIPagedEnumerableProps } from "./DTOs/GetModelo180DetalleImpuestosDtoIPagedEnumerable"
import { GetModelo180DtoProps } from "./DTOs/GetModelo180Dto"
import { GetModelo190DetalleImpuestosDto } from "./DTOs/GetModelo190DetalleImpuestosDto"
import { GetModelo190DetalleImpuestosDtoIPagedEnumerableProps } from "./DTOs/GetModelo190DetalleImpuestosDtoIPagedEnumerable"
import { GetModelo190DtoProps } from "./DTOs/GetModelo190Dto"
import { GetModelo303DtoProps } from "./DTOs/GetModelo303Dto"
import { GetModelo303ResumenImpuestosDtoProps } from "./DTOs/GetModelo303ResumenImpuestosDto"
import { GetModelo347DetalleImpuestosDto } from "./DTOs/GetModelo347DetalleImpuestosDto"
import { GetModelo347DetalleImpuestosDtoIPagedEnumerableProps } from "./DTOs/GetModelo347DetalleImpuestosDtoIPagedEnumerable"
import { GetModelo347DtoProps } from "./DTOs/GetModelo347Dto"
import { GetModelo349DtoProps } from "./DTOs/GetModelo349Dto"
import { GetModelo349ResumenImpuestosDtoProps } from "./DTOs/GetModelo349ResumenImpuestosDto"
import { GetModelo390ResumenImpuestosDtoProps } from "./DTOs/GetModelo390ResumenImpuestosDto"
import { GetModeloDetalleImpuestosAsientosContablesDtoBaseProps } from "./DTOs/GetModeloDetalleImpuestosAsientosContablesDtoBase"
import { GetModelo390DtoProps } from "./DTOs/GetModeloDto390"
import { LineasAsientosContablesByFilterDtoIProps } from "./DTOs/LineasAsientosContablesByFilterDto"
import { LineaAsientoContableSimpleReadingDtoIPagedEnumerableDiarioProps } from "./Schemas/GetLineaAsientoContablesByFiltersDtoIPagedEnumerable"
import { GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps } from "./Schemas/GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerable"
import { CuentaContableGrupoEnumType } from "./Types/CuentaContableGrupoEnum"
import { PeriodoType } from "./Types/Periodo"
import { TipoAsientoType } from "./Types/TipoAsiento"
import { TipoGrupoImpuestoType } from "./Types/TipoGrupoImpuesto"
import { TrimestreEnumType } from "./Types/TrimestreEnum"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface FetchDataRequest {
  Anyo?: string | number
  Keyword?: string
  TipoImpuestoIVA?: string | number
  SortingCriteria?: SortingCriteria
  MaxResultCount?: number | string
  SkipCount?: number | string
}

export interface FetchDataRequestImpuestosDetalle {
  Anyo: string | number
  Keyword?: string
  Periodo?: TrimestreEnumType
  TipoImpuestoIVA?: TipoGrupoImpuestoType
  SortingCriteria?: SortingCriteria | string
  MaxResultCount?: number
  SkipCount?: number
}

export interface AsientosContablesQueryParamsProps {
  cuentaContableId?: string
  fechaInicioAsiento?: string
  fechaFinAsiento?: string
  importeDebe?: number
  importeHaber?: number
  keyword?: string
  noPunteados?: boolean
  punteados?: boolean
  tipoAsiento?: TipoAsientoType
  sortingCriteria?: SortingCriteria
  maxResultCount?: number
  skipCount?: number
}

export interface AsientosContablesQueryParamsPropsNew {
  CuentaContableGrupos?: CuentaContableGrupoEnumType
  CuentaContableId?: string
  FechaLowerLimit?: string
  FechaUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Keyword?: string
  TipoAsiento?: TipoAsientoType
  IsEnabled?: boolean
  SortingCriteria?: SortingCriteria
  MaxResultCount?: number
  SkipCount?: number
}

// eslint-disable-next-line import/no-mutable-exports
export let LineaAsientosContableCall: CancelTokenSource | undefined
export const getLineaAsientosContable = async (
  queryParams: AsientosContablesQueryParamsPropsNew
): Promise<LineaAsientoContableSimpleReadingDtoIPagedEnumerableDiarioProps> => {
  if (typeof LineaAsientosContableCall !== typeof undefined) {
    LineaAsientosContableCall?.cancel("Previous Request Cancelled")
  }
  LineaAsientosContableCall = axios.CancelToken.source()
  const {
    data,
  }: { data: LineaAsientoContableSimpleReadingDtoIPagedEnumerableDiarioProps } =
    await axios.get(`/LineaAsientoContable/`, {
      params: queryParams,
      cancelToken: LineaAsientosContableCall.token,
    })
  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (asiento: LineasAsientosContablesByFilterDtoIProps) =>
        asientoDiarioByFilterAdapter(asiento)
    ),
    totalCount: data.totalCount,
  }
}

interface AsientoContableModelosParamsProps {
  Anyo?: string
  Periodo?: PeriodoType
}

export const getResumenIvaImpuestos = async (
  queryParams: AsientoContableModelosParamsProps
): Promise<GetModelo303DtoProps> => {
  const { data }: { data: GetModelo303DtoProps } = await axios.get(
    "/AsientoContable/modelo303",
    {
      params: queryParams,
    }
  )
  return {
    periodos: data.periodos?.map((periodo) =>
      AsientoContableModelo303Adapter(periodo)
    ),
  }
}

let ResumenAsientoContableCall: CancelTokenSource | undefined
export const getResumenDetalleIva303 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo303/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (linea: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) => {
        return ResumentImpuestoIvaDetalleAdapter(linea)
      }
    ),
    totalCount: data.totalCount,
  }
}

export async function getAsientoContableModelo390(
  queryParams: AsientoContableModelosParamsProps
): Promise<GetModelo390DtoProps> {
  const { data }: { data: GetModelo390DtoProps } = await axios.get(
    "/AsientoContable/modelo390",
    {
      params: queryParams,
    }
  )
  return {
    periodos: data.periodos?.map((periodo) =>
      AsientoContableModelo390Adapter(periodo)
    ),
  }
}

export const getResumenDetalleIva390 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo390/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (linea: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) => {
        return ResumentImpuestoIvaDetalleAdapter(linea)
      }
    ),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva347 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModelo347DetalleImpuestosDtoIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo347/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items.map((linea: GetModelo347DetalleImpuestosDto) => {
      return ResumentImpuestoIvaDetalle347Adapter(linea)
    }),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva349 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo349/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (linea: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) => {
        return ResumentImpuestoIvaDetalleAdapter(linea)
      }
    ),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva111 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo111/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items?.map(
      (linea: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) => {
        return ResumentImpuestoIvaDetalleAdapter(linea)
      }
    ),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva115 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModeloDetalleImpuestosAsientosContablesDtoBaseIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo115/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items.map(
      (linea: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) => {
        return ResumentImpuestoIvaDetalleAdapter(linea)
      }
    ),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva180 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModelo180DetalleImpuestosDtoIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo180/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items.map((linea: GetModelo180DetalleImpuestosDto) => {
      return ResumentImpuestoIvaDetalle180Adapter(linea)
    }),
    totalCount: data.totalCount,
  }
}

export const getResumenDetalleIva190 = async (
  queryParams?: FetchDataRequestImpuestosDetalle
): Promise<GetModelo190DetalleImpuestosDtoIPagedEnumerableProps> => {
  if (typeof ResumenAsientoContableCall !== typeof undefined) {
    ResumenAsientoContableCall?.cancel("Previous Request Cancelled")
  }
  ResumenAsientoContableCall = axios.CancelToken.source()
  const { data } = await axios.get(
    "AsientoContable/modelo190/detalle-impuestos",
    {
      params: queryParams,
      cancelToken: ResumenAsientoContableCall.token,
    }
  )

  return {
    currentPage: data.currentPage,
    items: data.items.map((linea: GetModelo190DetalleImpuestosDto) => {
      return ResumentImpuestoIvaDetalle190Adapter(linea)
    }),
    totalCount: data.totalCount,
  }
}

interface QueryParamsResumenImpuestos {
  FechaLowerLimit?: string
  FechaUpperLimit?: string
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

export const getResumenImpuestos303 = async (
  queryParams?: QueryParamsResumenImpuestos
): Promise<GetModelo303ResumenImpuestosDtoProps> => {
  const { data } = await axios.get(
    "/AsientoContable/modelo303/resumen-impuestos",
    {
      params: queryParams,
    }
  )

  return ResumentImpuesto303and390Adapter(data)
}
export const getResumenImpuestos390 = async (
  queryParams?: QueryParamsResumenImpuestos
): Promise<GetModelo390ResumenImpuestosDtoProps> => {
  const { data } = await axios.get(
    "/AsientoContable/modelo390/resumen-impuestos",
    {
      params: queryParams,
    }
  )

  return ResumentImpuesto303and390Adapter(data)
}

export const getResumenImpuestos349 = async (
  queryParams?: QueryParamsResumenImpuestos
): Promise<GetModelo349ResumenImpuestosDtoProps> => {
  const { data } = await axios.get(
    "/AsientoContable/modelo349/resumen-impuestos",
    {
      params: queryParams,
    }
  )

  return ResumenImpuesto349Adapter(data)
}

export const getResumenImpuestos111 = async (
  queryParams?: QueryParamsResumenImpuestos
): Promise<GetModelo111ResumenImpuestosDtoProps> => {
  const { data } = await axios.get(
    "/AsientoContable/modelo111/resumen-impuestos",
    {
      params: queryParams,
    }
  )

  return ResumenImpuestoOtrosAdapter(data)
}

export const getResumenImpuestos115 = async (
  queryParams?: QueryParamsResumenImpuestos
): Promise<GetModelo115ResumenImpuestosDtoProps> => {
  const { data } = await axios.get(
    "/AsientoContable/modelo115/resumen-impuestos",
    {
      params: queryParams,
    }
  )

  return ResumenImpuestoOtrosAdapter(data)
}

export const exportResumenDetalleIva303 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo303/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}
export const exportResumenDetalleIva390 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo390/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}

export const exportResumenDetalleIva111 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo111/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}

export const exportResumenDetalleIva349 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo349/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}

export const exportResumenDetalleIva115 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo115/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}

export const exportResumenDetalleIva180 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(
    `AsientoContable/modelo180/detalle-impuestos/contabilidad/excel`,
    {
      params: queryParams,
      responseType: "blob",
    }
  )
}
export const exportPerceptoresResumenDetalle180 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(
    `AsientoContable/modelo180/detalle-impuestos/perceptores/excel`,
    {
      params: queryParams,
      responseType: "blob",
    }
  )
}

export const exportResumenDetalleIva190 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(
    `AsientoContable/modelo190/detalle-impuestos/contabilidad/excel`,
    {
      params: queryParams,
      responseType: "blob",
    }
  )
}

export const exportPerceptoresResumenDetalle190 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(
    `AsientoContable/modelo190/detalle-impuestos/perceptores/excel`,
    {
      params: queryParams,
      responseType: "blob",
    }
  )
}

export const exportResumenDetalle347 = async (
  queryParams: FetchDataRequestImpuestosDetalle
) => {
  return axios.get(`AsientoContable/modelo347/detalle-impuestos/excel`, {
    params: queryParams,
    responseType: "blob",
  })
}

export const getAsientoContableExportarExcel = (
  queryParams: AsientosContablesQueryParamsProps
) => {
  return axios.get("/AsientoContable/exportar-excel", {
    params: queryParams,
    responseType: "blob",
  })
}

export async function getImportesTotalesAsientoContable(
  queryParams: AsientosContablesQueryParamsPropsNew
): Promise<GetImportesLineasAsientosContablesDto> {
  const { data } = await axios.get("/LineaAsientoContable/sumatorio-importes", {
    params: queryParams,
  })
  return ImportesTotalesAsientoContableAdapter(data)
}

export async function postAsientoDeLiquidacion(
  liquidacionData: InsertAsientoContableDeLiquidacionCommandProps
): Promise<string> {
  const { data }: Record<"data", string> = await axios.post(
    `/AsientoContable/liquidacion`,
    liquidacionData
  )
  return data
}

export function postCierreEjercicio(
  fechasCierreEjercicio: InsertAsientosCierreEjercicioCommandProps
) {
  return axios.post("/AsientoContable/cerrar-ejercicio", fechasCierreEjercicio)
}

export async function getAsientoContableModelo115(
  queryParams: AsientoContableModelosParamsProps
): Promise<GetModelo115DtoProps> {
  const { data }: { data: GetModelo115DtoProps } = await axios.get(
    "/AsientoContable/modelo115",
    {
      params: queryParams,
    }
  )
  return {
    periodos: data.periodos?.map((periodo) =>
      AsientoContableModelo115Adapter(periodo)
    ),
  }
}

interface AsientoContableModelo111ParamsProps {
  Anyo?: string
  Periodo?: PeriodoType
}
/**
 * Retrieves the AsientoContableModelo111 based on the provided query parameters.
 * @param queryParams - The query parameters for the request.
 * @returns A promise that resolves to the GetModelo111DtoProps object containing the retrieved data.
 */
export async function getAsientoContableModelo111(
  queryParams: AsientoContableModelo111ParamsProps
): Promise<GetModelo111DtoProps> {
  const { data }: { data: GetModelo111DtoProps } = await axios.get(
    "/AsientoContable/modelo111",
    {
      params: queryParams,
    }
  )
  return {
    periodos: data.periodos?.map((periodo) =>
      AsientoContableModelo111Adapter(periodo)
    ),
  }
}

export async function getAsientoContableModelo180(
  queryParams: AsientoContableModelo111ParamsProps
): Promise<GetModelo180DtoProps> {
  const { data }: { data: GetModelo180DtoProps } = await axios.get(
    "/AsientoContable/modelo180",
    {
      params: queryParams,
    }
  )
  return AsientoContableModelo180Adapter(data)
}

export async function getAsientoContableModelo190(
  queryParams: AsientoContableModelo111ParamsProps
): Promise<GetModelo190DtoProps> {
  const { data }: { data: GetModelo190DtoProps } = await axios.get(
    "/AsientoContable/modelo190",
    {
      params: queryParams,
    }
  )
  return AsientoContableModelo190Adapter(data)
}

export async function getAsientoContableModelo347(
  queryParams: AsientoContableModelo111ParamsProps
): Promise<GetModelo347DtoProps> {
  const { data }: { data: GetModelo347DtoProps } = await axios.get(
    "/AsientoContable/modelo347",
    {
      params: queryParams,
    }
  )
  return AsientoContableModelo347Adapter(data)
}

interface AsientoContableModelo349ParamsProps {
  Anyo?: string
  Periodo?: PeriodoType
}
/**
 * Retrieves the AsientoContableModelo349 based on the provided query parameters.
 * @param queryParams - The query parameters for the request.
 * @returns A promise that resolves to the GetModelo111DtoProps object containing the retrieved data.
 */
export async function getAsientoContableModelo349(
  queryParams: AsientoContableModelo349ParamsProps
): Promise<GetModelo349DtoProps> {
  const { data }: { data: GetModelo349DtoProps } = await axios.get(
    "/AsientoContable/modelo349",
    {
      params: queryParams,
    }
  )
  return {
    periodos: data.periodos?.map((periodo) =>
      AsientoContableModelo349Adapter(periodo)
    ),
  }
}

export async function postAsientosContablesImportSage(
  documento: ImportarAsientosContablesSageCommandProps
) {
  return axios.post("/AsientoContable/importar-sage", documento, {
    headers: {
      "Content-Type": "application/json",
    },
  })
}

export async function postLineasImpuestoImportSage(
  documento: ImportarLibroIvaSageCommandProps
) {
  return axios.post("/AsientoContable/importar-iva-sage", documento, {
    headers: {
      "Content-Type": "application/json",
    },
  })
}

export async function deleteAsientoContable(
  id: string
): Promise<AxiosResponse> {
  const response = await axios.delete(`/AsientoContable/${id}`)
  return response
}

export async function getAsientoById(
  id: string
): Promise<GetAsientoContableByIdDtoProps> {
  const { data } = await axios.get(`/AsientoContable/${id}`)
  return asientoByIdAdapter(data)
}

export async function postAsientoContable(
  asientoContable: InsertAsientoContableCommandProps
): Promise<{ status: number; data: string }> {
  const response = await axios.post(`/AsientoContable`, asientoContable)
  return { status: response.status, data: response.data }
}

export async function putAsientoContable(
  asientoContable: UpdateAsientoContableCommandProps
): Promise<AxiosResponse> {
  const response = await axios.put(
    `/AsientoContable/${asientoContable.id}`,
    asientoContable
  )
  return response
}

export async function postContraasiento(id: string): Promise<AxiosResponse> {
  const response = await axios.post(`/AsientoContable/${id}/contraasiento`)
  return response
}
